import { RenderDetailViewProps } from 'interfaces/model.interface'

import Detail from './Detail'
import { CandidateRankingData } from 'config/common/baseModel'

const Candidates = ({
  model,
  data,
  setSelectedRow,
  viewData,
}: RenderDetailViewProps<Record<CandidateRankingData, string>>) => {
  if (!data) {
    return null
  }
  return (
    <Detail
      model={model}
      title='name'
      candidate={data}
      handleClose={() => setSelectedRow(null)}
      viewData={viewData}
    />
  )
}

export default Candidates
